"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _excluded = ["name", "input", "meta", "loading", "options", "label", "disabled"],
    _excluded2 = ["id"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SelectAdapter = function SelectAdapter(_ref) {
  var _rest$id;

  var name = _ref.name,
      input = _ref.input,
      meta = _ref.meta,
      loading = _ref.loading,
      options = _ref.options,
      label = _ref.label,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  var props = function (_ref2) {
    var id = _ref2.id,
        properties = _objectWithoutProperties(_ref2, _excluded2);

    return properties;
  }(rest);

  var id = (_rest$id = rest.id) !== null && _rest$id !== void 0 ? _rest$id : input.name;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.FormControl, _extends({
    error: meta.error && meta.touched
  }, props, {
    id: "".concat(id, "-form-control"),
    margin: "dense"
  }), /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "".concat(input.name, "-label"),
    size: "small"
  }, label), /*#__PURE__*/_react.default.createElement(_material.Select, _extends({
    disabled: loading || disabled,
    name: input.name,
    labelId: "".concat(name, "-label"),
    label: label,
    value: loading ? -1 : input.value,
    onChange: input.onChange,
    onBlur: input.onBlur,
    size: "small",
    id: "".concat(id, "-select")
  }, props), loading ? /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: -1,
    key: -1
  }, "Loading...") : options), meta.error && meta.touched ? /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, meta.error) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)));
};

var _default = SelectAdapter;
exports.default = _default;